import { render, staticRenderFns } from "./batch-change.vue?vue&type=template&id=b56c681e&scoped=true"
import script from "./batch-change.vue?vue&type=script&lang=js"
export * from "./batch-change.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b56c681e",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/data/jenkins/data/workspace/KCC_AUDIT_PROD_Frontend/node_modules/vue-loader/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('b56c681e')) {
      api.createRecord('b56c681e', component.options)
    } else {
      api.reload('b56c681e', component.options)
    }
    module.hot.accept("./batch-change.vue?vue&type=template&id=b56c681e&scoped=true", function () {
      api.rerender('b56c681e', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/client-view/groupReporting/batch-change.vue"
export default component.exports